import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=3c841bbe&"
import script from "./Messaging.vue?vue&type=script&lang=js&"
export * from "./Messaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports